import { render, staticRenderFns } from "./responsiblePersonsEdit.vue?vue&type=template&id=56ccbb3a&scoped=true"
import script from "./responsiblePersonsEdit.vue?vue&type=script&lang=js"
export * from "./responsiblePersonsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_6d50957d97179d0c2dc3f7fe111d18c4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ccbb3a",
  null
  
)

export default component.exports